import Seo from "@/components/Seo";
import Newsletter from "@/components/Newsletter";
import Reveal from "@/components/Reveal";

const HERO = "https://images.unsplash.com/photo-1607423730403-b7fc1eb83ce0?crop=entropy&cs=srgb&fm=jpg&q=80&w=2400&ixlib=rb-4.1.0";

const VALORES = [
  { t: "Excelencia", d: "Creemos que cada libro merece ser tratado con cuidado y profesionalidad." },
  { t: "Compromiso", d: "Nuestros autores no son números. Detrás de cada obra existe una persona y una historia." },
  { t: "Propósito", d: "Buscamos obras que aporten algo significativo a sus lectores." },
  { t: "Cercanía", d: "Entendemos la relación editorial como un proceso de colaboración." },
  { t: "Pasión por los libros", d: "Amamos los libros y todo el proceso que permite que una idea termine en las manos de un lector." },
];

export default function Nosotros() {
  return (
    <>
      <Seo title="Nosotros" description="Editorial Harvest, donde comienza la excelencia. Más de una década publicando obras con propósito." />
      <section className="relative overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0a1b33]/78" />
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 pt-40 pb-24 md:pt-52 md:pb-32 text-center">
          <p className="hv-overline hv-overline-light">Editorial Harvest</p>
          <h1 className="font-serif font-light text-white text-5xl md:text-7xl lg:text-8xl mt-6 tracking-tight leading-[0.98]">
            Donde comienza<br />la excelencia
          </h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 py-24 md:py-32">
        <Reveal className="space-y-6 text-[#4a4a45] leading-relaxed text-lg md:text-xl font-light">
          <p>Editorial Harvest nació con la voluntad de publicar libros capaces de aportar valor a la vida de las personas.</p>
          <p>Lo que comenzó hace más de una década como un proyecto dedicado a la edición de literatura cristiana ha crecido hasta convertirse en una editorial que ha acompañado a autores de diferentes países y trayectorias.</p>
          <p>Apostamos por autores emergentes y por voces consolidadas, pero sobre todo por obras que tengan algo que decir.</p>
          <p className="font-serif text-2xl md:text-3xl text-[#0f2544] italic pt-2">A lo largo de nuestra trayectoria hemos editado más de 100 títulos y trabajado con más de 40 autores.</p>
        </Reveal>
      </section>

      <section className="bg-[#eceae4]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-16 grid md:grid-cols-2 gap-10">
          <div className="rounded-lg bg-white border border-[#0f2544]/10 p-8">
            <p className="hv-overline">Nuestra misión</p>
            <p className="text-[#4a4a45] mt-4 leading-relaxed">
              Publicar y desarrollar obras de calidad que transmitan conocimiento, fe, experiencias y
              mensajes capaces de aportar valor a sus lectores.
            </p>
          </div>
          <div className="rounded-lg bg-white border border-[#0f2544]/10 p-8">
            <p className="hv-overline">Nuestra visión</p>
            <p className="text-[#4a4a45] mt-4 leading-relaxed">
              Construir una editorial reconocida por la calidad de sus publicaciones, el cuidado de sus
              autores y su capacidad para llevar buenos libros a lectores de diferentes lugares del mundo.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12 py-16 md:py-24">
        <div className="text-center mb-12">
          <p className="hv-overline">Nuestros valores</p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#0f2544] mt-3">Lo que nos define</h2>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {VALORES.map((v) => (
            <div key={v.t} className="rounded-lg border border-[#0f2544]/10 bg-white p-7">
              <h3 className="font-serif text-xl text-[#0f2544]">{v.t}</h3>
              <p className="text-[#4a4a45] mt-2 leading-relaxed text-sm">{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      <Newsletter />
    </>
  );
}
